<template>
  <div style="width: 100%">
    <div class="readiness-container pt-8">
      <PageTitle
        class="page-title"
        title="Employees Readiness"
        show_help_menu
        :counter_count="activeEmployeesCount"
        :counter_label="'Active'"
      />
      <div class="path-to-readiness-bar">
        <PathToReadinessBar
          :readiness="viewState.state.readiness.average_readiness"
          :showRecalculate="false"
          :readinessTitle="'Average Readiness'"
          :loading="readinessLoading"
        />
      </div>
    </div>
    <ReadinessEmployeeView />
  </div>
</template>

<script setup>
import { onMounted, getCurrentInstance, computed } from "vue";
import { useReadinessEmployees } from "@/composables/readinessEmployees/useReadinessEmployees";
import ReadinessEmployeeView from "@/views/ReadinessEmployees/ReadinessEmployeeView.vue";
import PageTitle from "@components/common/PageTitle.vue";
import { useReadinessEmployeeViewState } from "@/views/ReadinessEmployees/composables/useReadinessEmployeeViewState";
import PathToReadinessBar from "@components/PathToReadinessBar/PathToReadinessBar.vue";
const app = getCurrentInstance();
const { proxy } = app;
const viewState = useReadinessEmployeeViewState();
const employees = useReadinessEmployees();
const readinessLoading = computed(() => {
  return viewState.state.readiness.loading;
});
const activeEmployeesCount = computed(() => {
  return employees.employeeStore.getTotalEmployeesCount;
});
onMounted(async () => {
  proxy.$loader.show();
  await viewState.loadAccountDetails();
  proxy.$loader.hide();
});
</script>

<style scoped>
.readiness-container {
  padding-left: 12px;
  width: 100%;
}
.path-to-readiness-bar {
  padding-top: 8px;
  margin-right: 12px;
}
</style>
